<template>
  <div>
    <div
      class="panel-row-without-selector mb-4 pb-3 pt-3 mr-0 ml-0 row"
    >
      <div class="col-4 pt-0 info">
        <slot name="firstColumn" />
      </div>
      <div class="col-4 pt-0 info">
        <slot name="secondColumn" />
      </div>
      <div class="col info text-right pt-3">
        <button
          class="btn btn-dropdown-actions dropdown-toggle pt-1"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Acciones
        </button>
        <div class="dropdown-menu dropdown-menu-right pb-0">
          <a
            v-for="action in actions"
            :key="action.name"
            class="drop-item"
            href="javascript:void(0)"
            @click="action.click"
          >
            <i :class="`fas ${action.icon} pr-1`" />
            <span :data-node="node">{{ action.name }}</span>
          </a>
        </div>
      </div>
    </div>
    <div style="position: relative;bottom: 17px;">
      <Error v-if="hasError" variant="no-border" message="Informe Académico no contiene documento." />
      <Error v-if="!hasError && file?.errorMessage != null" variant="no-border" :message="file.errorMessage" />
    </div>
  </div>
</template>

<script>
import Error from '@/components/common/Error.vue';

export default {
  name: "DocumentLayout",
  props: {
    actions: Array,
    node: Number,
    isRow: {
      type: Boolean,
      default: true
    },
    hasError: {
      type: Boolean,
      default: false
    },
    file: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    Error
  }
};
</script>

<style scoped>
.btn-dropdown-actions {
  border-color: #2b9d71 !important;
}
.panel-row-without-selector{
  background-color: #fafafa;
}
.drop-item {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
  text-decoration: none !important;
}
</style>
